import { Component, Input, OnInit } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';

@Component({
  selector: 'app-bot-message',
  templateUrl: './bot-message.component.html',
  styleUrls: ['./bot-message.component.css']
})
export class BotMessageComponent implements OnInit {
  @Input() content!: string;
  @Input() title?: string;
  @Input() showImage!: boolean;
  @Input() timestamp!: number;
  
  constructor(public chatbotFunService: ChatbotFunService) {} 

  ngOnInit() {
  }

}
